import { decisionTypes } from '@/returns/components/OrderSelector/constants'

const buildAssignment = item => {
  if (item.decision.type === decisionTypes.link) {
    return {
      unexpected_item_id: item.id,
      action: decisionTypes.link,
      target_order_id: item.decision.order.id,
    }
  }

  return {
    unexpected_item_id: item.id,
    action: decisionTypes.discard,
  }
}

export const buildAssignments = items => items.filter(item => item.decision).map(buildAssignment)
